import { IonCard, IonCardHeader } from "@ionic/react";
import { useEffect, useState } from "react";
import { Bar, BarChart, ResponsiveContainer, Tooltip, XAxis } from "recharts";
import { makeGETRequest } from "../../../request/rawRequest";
import User from "../../../services/User";

interface Props {}

const Time: React.FC<Props> = ({}) => {
  const [time, setTime] = useState<{ name: string; time: number }[]>([]);

  const getTime = (email: string) => {
    makeGETRequest("/time?email=" + email).then((res) => {
      setTime([]);
      res.sort((a: any, b: any) => a.week_nb - b.week_nb);
      res = res.slice(-4);

      for (const week of res) {
        const { week_nb, time } = week;
        const monday = new Date(week_nb);
        const displayMonday =
          monday.getDate() +
          "/" +
          (monday.getMonth() + 1) +
          " au " +
          (monday.getDate() + 7) +
          "/" +
          (monday.getMonth() + 1);
        setTime((old) => [
          ...old,
          {
            name: displayMonday,
            time: parseFloat((time / 1000 / 3600).toFixed(2)),
          },
        ]);
      }
    });
  };

  useEffect(() => {
    getTime(User.getUserEmail());
  }, []);

  return (
    <IonCard className="border-primary-contrast border-radius">
      <IonCardHeader>
        <h5
          style={{
            color: "black",
          }}
        >
          Mon temps par semaine
        </h5>
      </IonCardHeader>
      <div
        style={{
          height: 300,
          margin: "10px 0 10px 0",
        }}
      >
        <ResponsiveContainer width="100%" height="100%">
          <BarChart width={150} height={40} data={time}>
            <Tooltip />
            <Bar
              name="Nombre d'heures"
              dataKey="time"
              fill="var(--ion-color-secondary-shade)"
              radius={[30, 30, 0, 0]}
            />

            <XAxis
              dataKey="name"
              interval={0}
              height={50}
              angle={-15}
              tick={{ dy: 20 }}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </IonCard>
  );
};

export default Time;
